
import { Component, Prop, Vue } from 'vue-property-decorator'
@Component({
    name: 'Header'
})
export default class extends Vue {
    @Prop({default: 'transparent'})readonly bgColor!: string
    @Prop({default: false})readonly isShowSearch!: boolean
    @Prop({default: false})readonly isShowShow!: boolean
    private goSearch() {
        this.$jump('/search')
    }
}
